import { FC } from 'react'
import { IMovies } from '../../models/IMovies'
import './GenreOneItem.scss'
import { Link } from 'react-router-dom'
import noImg from '../../assets/img/no-img.webp'

interface GenreOneItem {
    movieFilterGenre: IMovies
}

export const GenreOneItem: FC<GenreOneItem> = ({ movieFilterGenre }) => {

    return (
        <article className='genre'>
            <Link className='' to={`/movie/${movieFilterGenre.id}`} key={movieFilterGenre.id}>
                <img className='genre__img' src={movieFilterGenre.posterUrl !== null ? movieFilterGenre.posterUrl : noImg} alt={movieFilterGenre.title} />
            </Link>
        </article>

    )
}